const DISH_LOAD = "DISH_LOAD";
const DISH_LOAD_SUCCESS = "DISH_LOAD_SUCCESS";
const DISH_LOAD_FAIL = "DISH_LOAD_FAIL";

const DISH_CHANGE_ATTR = "DISH_CHANGE_ATTR";

const DISH_UPDATE = "DISH_UPDATE";
const DISH_UPDATE_SUCCESS = "DISH_UPDATE_SUCCESS";
const DISH_UPDATE_FAIL = "DISH_UPDATE_FAIL";

const MODIFIER_UPDATE = "MODIFIER_UPDATE";
const MODIFIER_UPDATE_SUCCESS = "MODIFIER_UPDATE_SUCCESS";
const MODIFIER_UPDATE_FAIL = "MODIFIER_UPDATE_FAIL";

const DISH_ARCHIVE = "DISH_ARCHIVE";
const DISH_ARCHIVE_SUCCESS = "DISH_ARCHIVE_SUCCESS";
const DISH_ARCHIVE_FAIL = "DISH_ARCHIVE_FAIL";

const DISH_NEW_LOAD = "DISH_NEW_LOAD";
const DISH_NEW_LOAD_SUCCESS = "DISH_NEW_LOAD_SUCCESS";
const DISH_NEW_LOAD_FAIL = "DISH_NEW_LOAD_FAIL";

const DISH_NEW_SAVE = "DISH_NEW_SAVE";
const DISH_NEW_SAVE_SUCCESS = "DISH_NEW_SAVE_SUCCESS";
const DISH_NEW_SAVE_FAIL = "DISH_NEW_SAVE_FAIL";

const DISH_ADD_MODIFIER = "DISH_ADD_MODIFIER";
const DISH_ADD_MODIFIER_SUCCESS = "DISH_ADD_MODIFIER_SUCCESS";
const DISH_ADD_MODIFIER_FAIL = "DISH_ADD_MODIFIER_FAIL";

export const DISH_ADD_RESTAURANT = "DISH_ADD_RESTAURANT";
export const DISH_CHANGE_TAG = "DISH_CHANGE_TAG";
export const DISH_CHANGE_TAX = "DISH_CHANGE_TAX";

export const ALLERGENS_LOAD = "ALLERGENS_LOAD";
export const ALLERGENS_LOAD_SUCCESS = "ALLERGENS_LOAD_SUCCESS";
export const ALLERGENS_LOAD_FAIL = "ALLERGENS_LOAD_FAIL";

export const DISH_CHANGE_ALLERGENS = "DISH_CHANGE_ALLERGENS";

export const ALLERGENS_UPDATE = "ALLERGENS_UPDATE";
export const ALLERGENS_UPDATE_SUCCESS = "ALLERGENS_UPDATE_SUCCESS";
export const ALLERGENS_UPDATE_FAIL = "ALLERGENS_UPDATE_FAIL";

export const onAllergensLoad = (allergens) => ({type: ALLERGENS_LOAD,allergens});
export const onAllergensLoadSuccess = (data) => ({type: ALLERGENS_LOAD_SUCCESS, data});
export const onAllergensLoadFail = (e) => ({ type: ALLERGENS_LOAD_FAIL, e });

export const onAllergensUpdate = (allergens) => ({type: ALLERGENS_UPDATE, allergens});
export const onAllergenshUpdateSuccess = (data) => ({type: ALLERGENS_UPDATE_SUCCESS, data});
export const onAllergensUpdateFail = (e) => ({type: ALLERGENS_UPDATE_FAIL, e});

export const onDishChangeAllergens = (allergens) => ({type: DISH_CHANGE_ALLERGENS,allergens});
export const onDishChangeTag = (tag) => ({ type: DISH_CHANGE_TAG, tag });
export const onDishChangeTaxes = (tag) => ({ type: DISH_CHANGE_TAX, tag });

export const onDishNewLoad = () => ({ type: DISH_NEW_LOAD });
export const onDishNewLoadSuccess = (data) => ({type: DISH_NEW_LOAD_SUCCESS,data});
export const onDishNewLoadFail = (e) => ({ type: DISH_NEW_LOAD_FAIL, e });

export const onDishNewSave = (photo, selectedIds, isCheckAllFutureLocations, isCheckAll) => ({
    type: DISH_NEW_SAVE, photo, selectedIds, isCheckAllFutureLocations, isCheckAll});
export const onDishNewSaveSuccess = (data) => ({type: DISH_NEW_SAVE_SUCCESS,data});
export const onDishNewSaveFail = (e) => ({ type: DISH_NEW_SAVE_FAIL, e });

export const onDishLoad = (itemId) => ({type: DISH_LOAD,itemId});
export const onDishLoadSuccess = (data) => ({ type: DISH_LOAD_SUCCESS, data });
export const onDishLoadFail = (e) => ({ type: DISH_LOAD_FAIL, e });

export const onDishUpdate = (photo, selectedIds, isCheckAllFutureLocations, isCheckAll) => ({
    type: DISH_UPDATE, photo, selectedIds, isCheckAllFutureLocations, isCheckAll});
export const onDishUpdateSuccess = (data) => ({type: DISH_UPDATE_SUCCESS,data});
export const onDishUpdateFail = (e) => ({ type: DISH_UPDATE_FAIL, e });

export const onModifierUpdate = () => ({type: MODIFIER_UPDATE});
export const onModifierUpdateSuccess = (data) => ({type: MODIFIER_UPDATE_SUCCESS,data});
export const onModifierUpdateFail = (e) => ({ type: MODIFIER_UPDATE_FAIL, e });

export const onDishArchive = (archived) => ({ type: DISH_ARCHIVE, archived });
export const onDishArchiveSuccess = (data) => ({ type: DISH_ARCHIVE_SUCCESS, data });
export const onDishArchiveFail = (e) => ({ type: DISH_ARCHIVE_FAIL, e });

export const onDishChangeAttribute = (attr, value) => ({type: DISH_CHANGE_ATTR,attr,value});

export const onDishAddModifier = (item) => ({type: DISH_ADD_MODIFIER,item});

export const onDishAddRestaurant = (index) => ({type: DISH_ADD_RESTAURANT,index});
